import { render, staticRenderFns } from "./downloadlogtable.vue?vue&type=template&id=23c54bda&scoped=true&"
import script from "./downloadlogtable.vue?vue&type=script&lang=js&"
export * from "./downloadlogtable.vue?vue&type=script&lang=js&"
import style0 from "./downloadlogtable.vue?vue&type=style&index=0&id=23c54bda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c54bda",
  null
  
)

export default component.exports